export default "__VITE_ASSET__tfRVa$mt__"